import { render, staticRenderFns } from "./HistoricoImportacaoFilter.vue?vue&type=template&id=43edbf3d&scoped=true"
import script from "./HistoricoImportacaoFilter.vue?vue&type=script&lang=js"
export * from "./HistoricoImportacaoFilter.vue?vue&type=script&lang=js"
import style0 from "./HistoricoImportacaoFilter.vue?vue&type=style&index=0&id=43edbf3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43edbf3d",
  null
  
)

export default component.exports